<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-6 col-7">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a [routerLink]="['/']" href="javascript:void(0)">
                  <i class=" fas fa-home"></i>
                </a>
              </li>

              <li class=" breadcrumb-item">
                <a href="javascript:void(0)">Funding opportunities</a>
              </li>

            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>

<div class=" container-fluid mt--6">
  <div class=" row">
    <div class=" col-lg">
      <div class=" card-wrapper">
        <div class="card">
          <div class=" card-header border-0"><h3 class=" mb-0">Funding opportunities</h3>
          </div>


          <div class="table-responsive">
            <table class="table table-flush">
              <thead class="thead-light">
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Application
                  Deadline
                </th>
                <th scope="col"></th>
              </tr>
              </thead>

              <tbody class="list">
              <tr *ngFor="let project of projects; index as i">
                <td scope="row">
                  {{ project.projectName }}
                </td>
                <td>
                        <span class="mr-4 text-wrap">
<!--                          <span class="status ">{{ project.projectDescription | truncateWordWithNoSpace:20 }}</span>-->
                          <span class="status ">{{project.projectDescription  | truncateWordWithNoSpace:200}}</span>

                        </span>
                </td>
                <td>
                  <span class="status ">{{ project.applicationDueDate|date:'dd/MM/yyy' }}</span>
                </td>
                <td>
                  <div class="d-block mb-2">
                    <a *ngIf="project.allowFullSubmit" [routerLink]="['detail', project.projectId]" class="btn btn-success btn-sm d-block mb-2">
                      <i class="fas fa-file-alt"></i> Apply for Project Grant
                    </a>
                    <a *ngIf="project.allowEmergencySubmit" [routerLink]="['emergency', project.projectId]" class="btn btn-danger btn-sm d-block">
                      <i class="fas fa-exclamation-triangle"></i> Apply for Emergency Grant
                    </a>
                  </div>
                </td>

              </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer py-4">
            <nav aria-label="...">
              <pagination (pageChanged)="pageChanged($event)"
                          [(ngModel)]="currentPage"
                          [boundaryLinks]="true"
                          [customNextTemplate]="nextTemplate"
                          [customPreviousTemplate]="prevTemplate"
                          [disabled]="disabled"
                          [itemsPerPage]="configTableMaxRow"
                          [maxSize]="5"
                          [totalItems]="totalItems"
                          class="justify-content-end mb-0">
              </pagination>
              <ng-template #nextTemplate let-currentPage="currentPage">
                <ng-container *ngIf="!disabled">
                  <i class='fas fa-angle-right'></i>
                </ng-container>
              </ng-template>

              <ng-template #prevTemplate let-currentPage="currentPage">
                <ng-container *ngIf="!disabled">
                  <i class='fas fa-angle-left'></i>
                </ng-container>
              </ng-template>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
